@if (fromVibeCoding) {
  <form [formGroup]="outlineFormGroup" class="create-ai-assistant-form-view__wrap">
    <div class="db-first-half">
      <h3 class="db-title">
        What's your site about?
      </h3>
      <p class="db-desc">
        Add details about your brand or experience.</p>
      <div class="ds-input-wrap desc mt30 create-ai-assistant-vibe-textarea">
        <span class="ds-input-label">Describe your company</span>
        <div class="create-ai-assistant-vibe-textarea-container">
          <db-vc-image-upload (closeFigma)="showFigmaLink.set(false)"
                              [descInput]="descInput"
                              [showFigmaLink]="showFigmaLink()"
                              (fileInputTrigger)="fileInput = $event">

          </db-vc-image-upload>

          <textarea
            #descInput
            formControlName="business_description"
            (keydown)="onKeyDown($event)"
            placeholder="Describe your restaurant
Ex. Cozy family restaurant, where delicious home-style meals and warm hospitality create the perfect atmosphere for enjoying time."
            maxlength="4000"
            class="ds-textarea ds-textarea-black big no-resize vibe-description"
            [class.ds-textarea-error]="outlineFormGroup.get('business_description')?.invalid && outlineFormGroup.get('business_description')?.touched">
          </textarea>
          <div class="vibe-textarea-tools"
               [dsTooltipPosition]="'bottom'"
               [dsTooltipAlign]="'left'"
               [dsTooltipMode]="'hoverStatic'"
               [dsTooltipSize]="'large'"
               [dsTooltipTopPxs]="13"
               [dsTooltip]="tools"
               >
            <i class="db-icon db-icon-ds-big-plus"></i>
            <ng-template #tools>
              <div class="tools-dropdown" [class.close]="closeTooltip()">
                <div class="dropdown-item" (click)="openFileDialog()">
                  <i class="db-icon db-icon-ds-image-upload"></i>
                  <span>{{ 'text_attachAMedia' | dbText }}</span>
                </div>
                <!--<div class="dropdown-item" (click)="addFigma()">
                  <img src="./assets/images/logos/figma-logo.svg">
                  <span>{{ 'text_importFrom' | dbText }} Figma</span>
                </div>-->
              </div>
            </ng-template>
          </div>
        </div>

        @if (outlineFormGroup.get('business_description')?.invalid && outlineFormGroup.get('business_description')?.touched) {
          <span class="ds-input-error-msg">
            Description is required and must be at least 10 characters long.
          </span>
        }
      </div>
    </div>
  </form>
} @else {
  <form [formGroup]="outlineFormGroup" class="create-ai-assistant-form-view__wrap"
        xmlns="http://www.w3.org/1999/html">
    <div class="db-first-half">
      <h4 class="db-title mb8">
        @if (isEcommerce) {
          What’s your store about?
        } @else {
          What's your site about?
        }
      </h4>
      <span class="db-desc">
      @if (isEcommerce) {
        Add details about your products and brand.
      } @else {
        Add details about your brand or experience.
      }
    </span>

      <div class="mt40">
        <ng-container *ngIf="!TypeUtils.isEmpty(formGroupData); else fallbackContent">
          <ng-container *ngFor="let input of formGroupData?.inputs">
            <div *ngIf="input?.field_type === 'text' && input?.name !== domainNameKey"
                 [ngClass]="{'full-width': input?.full_width}"
                 class="ds-input-wrap mb9 {{input?.titleDesc}}">
              <span class="ds-input-label">{{ input?.label }}<span class="db-title-desc ml3"
                                                                   *ngIf="input?.titleDesc">{{ input?.titleDesc }}</span></span>
              <input [formControlName]="input?.name"
                     #companyName
                     [ngClass]="{'error': (outlineFormGroup?.get(input?.name)?.touched && ((outlineFormGroup?.get(input?.name).invalid) || outlineFormGroup?.get(input?.name)?.value.length >= 200))}"
                     [placeholder]="input?.placeholder"
                     [attr.maxLength]="200"
                     class="ds-input ds-input-black" type="{{input?.input_type === 'integer' ? 'number' : 'text'}}">
              <span
                *ngIf="outlineFormGroup?.get(input?.name)?.touched &&  ((outlineFormGroup?.get(input?.name).invalid) || (outlineFormGroup?.get(input?.name)?.value.length >= 200))"
                [innerHTML]="outlineFormGroup?.get(input?.name)?.errors?.required ? 'This field is required.' :
                  outlineFormGroup?.get(input?.name)?.errors?.minlength ? 'To get better results input no less than ' + input?.min_character_limit + ' symbols.'
                  : outlineFormGroup?.get(input?.name)?.value.length >= 200 ? 'Character limit reached.' : ''"
                class="ds-input-error-msg"></span>
            </div>

            <div *ngIf="input?.field_type === 'textarea'" [ngClass]="{'full-width': input?.full_width}"
                 class="ds-input-wrap mb9">
              <div [ngClass]="{'with-enhance': input?.with_enhance}" class="ds-textarea-label-wrap">
                <span *ngIf="input?.label" class="ds-input-label" [innerHTML]="input?.label"></span>
                <a (click)="generateDescription(outlineFormGroup?.get(input?.name)?.value, input?.name)"
                   *ngIf="input?.with_enhance"
                   [ngClass]="{'ds-disabled': (builderInteractionsService.generateDescriptionLoading | async) || (outlineFormGroup?.get(input?.name).invalid)
          || (input?.min_character_limit && (outlineFormGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit) }"
                   class="generate-ai">
                  <img *ngIf="!(builderInteractionsService.generateDescriptionLoading | async)"
                       [src]="(outlineFormGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit || outlineFormGroup?.get(input?.name).invalid  ?
             'assets/images/icons/enhance_with_ai_disabled.svg' : 'assets/images/icons/enhance_with_ai_active.svg'">
                  <db-loading-circular-spinner *ngIf="(builderInteractionsService.generateDescriptionLoading | async)"
                                               [color]="'blue'" [size]="'xs_small'"
                                               class="mr8"></db-loading-circular-spinner>
                  <span>{{ (builderInteractionsService.generateDescriptionLoading | async) ? 'Generating...' : 'Enhance with AI' }}</span>
                </a>
              </div>
              <textarea [formControlName]="input?.name" [ngClass]="{'error': (outlineFormGroup?.get(input?.name)?.touched && (outlineFormGroup?.get(input?.name).invalid || (outlineFormGroup?.get(input?.name)?.value.length >= 1000))) || !!serverErrors
                  || (outlineFormGroup?.get(input?.name)?.touched && input?.min_character_limit && (outlineFormGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit)}"
                        [placeholder]="input?.placeholder "
                        [attr.maxLength]="4000"
                        #companyDescription
                        class="ds-textarea ds-textarea-black big no-resize"
                        rows="4"></textarea>
              <span *ngIf="(outlineFormGroup?.get(input?.name)?.touched && (outlineFormGroup?.get(input?.name).invalid || (outlineFormGroup?.get(input?.name)?.value.length >= 1000))) || !!serverErrors
             || (outlineFormGroup?.get(input?.name)?.touched && input?.min_character_limit && (outlineFormGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit)"
                    [innerHTML]="!!serverErrors ? serverErrors?.massage : (outlineFormGroup?.get(input?.name)?.errors?.minlength || ((outlineFormGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit) ? 'To get better results input no less than ' + input?.min_character_limit + ' symbols.'
          : (outlineFormGroup?.get(input?.name)?.errors?.required ? 'This field is required.' : (outlineFormGroup?.get(input?.name)?.touched && outlineFormGroup?.get(input?.name).invalid ? 'Character limit reached.' : '')))"
                    class="ds-input-error-msg">
      </span>
            </div>

            <div *ngIf="input?.field_type === 'text' && input?.name === domainNameKey && !hasFilledDomainName">
              <div class="db-onboarding__domain">
                <div class="db-onboarding__domain-title">
                  <p>
                    @if (isMobile) {
                      Do you have domain?
                    } @else {
                      Do you own a domain for your website?
                    }</p>
                </div>
                <div class="db-onboarding__domain-options">
                  <p (click)="domainShow('yes')"
                     [ngClass]="{'selected': showDomainInput === 'yes'}">Yes
                  </p>
                  <p (click)="domainShow('no')"
                     [ngClass]="{'selected': showDomainInput === 'no'}">No
                  </p>
                </div>
              </div>

              <div *ngIf="showDomainInput === 'no'" class="mt10">
                <input [formControlName]="input?.name" [placeholder]="input?.placeholder || oldFormData['domain_name']"
                       class="ds-input"
                       type="text">
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="db-create-company-info-mobile first-step" *ngIf="!!isMobile">
      <button (click)="onGenerate()"
              class="ds-btn-ls {{isMobile && isEcommerce}}"
              [ngClass]="{'ds-btn-disabled': (builderInteractionsService.generateDescriptionLoading | async) || (showDomainInput === '' && outlineFormGroup?.get('domain_name')) || outlineFormGroup?.invalid, 'ds-btn-black': !isMobile || isEcommerce, 'ds-btn-purple-blue': isMobile && !isEcommerce}">
        <ng-container *ngIf="!(builderInteractionsService.loading|async); else spinner">
          <img *ngIf="!isEcommerce" [src]="'assets/images/icons/ai-generate-white.svg'" alt=""/>
          <span>{{ isMobile && !isEcommerce ? 'Generate Your Website' : 'Next' }}</span>
        </ng-container>
        <ng-template #spinner>
          <db-loading-circular-spinner></db-loading-circular-spinner>
        </ng-template>
      </button>
    </div>

  </form>


  <ng-template #fallbackContent>
    <div class="fallback-form">
      <div class="ds-input-wrap mb9">
        <span class="ds-input-label">Enter company name</span>
        <span class="ds-fake-input ds-lazy-load"></span>
      </div>
      <div class="ds-input-wrap mb9">
        <span class="ds-input-label">Describe your company</span>
        <span class="ds-fake-textarea ds-lazy-load"></span>
      </div>

      <span class="ds-fake-input mt30 m ds-lazy-load"></span>
    </div>

  </ng-template>
}


